import React from "react";
import LazyLoad from "react-lazy-load";

import AvatarPlaceholder from "src/images/avatar-purple.svg";

interface PersonDropdownItem {
  name: string;
  avatarUrl?: string;
  email: string;
}

export default function PersonDropdownItem({
  name,
  avatarUrl,
  email,
}: PersonDropdownItem) {
  return (
    <div className="member-option person-dropdown-item" data-value={name}>
      <LazyLoad
        offset={300}
        width={24}
        height={24}
        className="member-option__photo-loader"
      >
        <img
          className="member-option__photo"
          src={avatarUrl || AvatarPlaceholder}
          alt="avatar"
        />
      </LazyLoad>
      <div className="member-option__name">{name}</div>
      <div className="member-option__email">{email}</div>
    </div>
  );
}
